import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import asyncLogin from '../../store/thunks/auth/asyncLogin';

import Button from "../Button/Button";
import Input from "../Input/Input";

import './LoginForm.scss';

export default function LoginForm() {
    const authStore = useSelector((store) => store.auth);
    const dispatch = useDispatch();

    const [form, setForm] = useState({});
    const [formError, setFormError] = useState();
    const { register, formState: { errors }, handleSubmit } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        const {isAuth} = authStore;
        isAuth && navigate('/employees');

        const {error} = authStore;

        setFormError(error);
    }, [authStore]);

    useEffect(() => {
        dispatch(asyncLogin(form));
    }, [form]);

    return (
        <div className="form-wrapper">
            <form className="form login-form" onSubmit={handleSubmit(setForm)}>
                <h2 className="title">Вход в личный кабинет</h2>
                <div className="input-wrapper">
                    <label className="label">Логин</label>
                    <input 
                        className="input" 
                        {...register("login", {
                            required: true
                        })}
                    />
                    {errors?.login && <span className="input__error">Поле обязательно для заполнения</span>}
                </div>
                <div className="input-wrapper">
                    <label className="label">Пароль</label>
                    <input 
                        className="input" 
                        type="password" 
                        {...register("password", {
                            required: true
                        })}
                    />
                    {errors?.password && <span className="input__error">Поле обязательно для заполнения</span>}
                </div>
                <Button className="blue" type="submit">Войти</Button>
                {formError && <span className="form__error">{formError}</span>}
            </form>
        </div>
    );
}